<div class="registration-entry-editor">
  <div class="registration-entry-editor__header">
    <h3 class="registration-entry-editor__title">{{ mode === 'add' ? addTitle : editTitle }}</h3>

    <button
      mat-icon-button
      type="button"
      class="registration-entry-editor__close"
      [matTooltip]="cancelTooltip"
      (click)="cancel.emit()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <ng-content></ng-content>

  <ng-content select="[invalidAlert]"></ng-content>

  <ui-alert type="warning" *ngIf="invalid">
    <div ui-header *ngIf="invalidHeader; else defaultInvalidHeader">{{ invalidHeader }}</div>
    <ng-template #defaultInvalidHeader>
      <div ui-header i18n>לא ניתן לשמור מכיון שאחד או יותר מהפרטים שגויים או חסרים</div>
    </ng-template>

    <p ui-body *ngIf="invalidBody; else defaultInvalidBody">{{ invalidBody }}</p>
    <ng-template #defaultInvalidBody>
      <span i18n>חובה למלא את כל השדות</span>
    </ng-template>
  </ui-alert>

  <div class="registration-entry-editor__actions">
    <button mat-button type="button" (click)="cancel.emit()" i18n>ביטול</button>
    <button mat-raised-button color="primary" type="button" (click)="save.emit()" i18n>שמור</button>
  </div>
</div>
